import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card, Table, Tag, Button, Space, Spin, Typography, Avatar, Input, message,
} from 'antd';
import {
  UserOutlined, SearchOutlined, TeamOutlined, LoginOutlined,
} from '@ant-design/icons';
import { authAPI } from '../services/api';

const { Title, Text } = Typography;

export default function CustomerListPage() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await authAPI.getUsers();
        const customers = (res.data || []).filter(u => u.role === 'customer');
        setUsers(customers);
      } catch (e) {
        message.error('載入客戶列表失敗');
      }
      setLoading(false);
    })();
  }, []);

  const filtered = users.filter(u => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (u.display_name || '').toLowerCase().includes(q)
      || (u.username || '').toLowerCase().includes(q)
      || (u.company_name || '').toLowerCase().includes(q)
      || (u.email || '').toLowerCase().includes(q);
  });

  const columns = [
    {
      title: '客戶',
      key: 'user',
      render: (_, record) => (
        <Space>
          <Avatar size={36} icon={<UserOutlined />} style={{ background: '#1890ff' }} />
          <div>
            <div style={{ fontWeight: 600 }}>{record.display_name}</div>
            <Text type="secondary" style={{ fontSize: 12 }}>{record.username}</Text>
          </div>
        </Space>
      ),
    },
    {
      title: '公司',
      dataIndex: 'company_name',
      key: 'company',
      render: (v) => v || <Text type="secondary">-</Text>,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (v) => v || <Text type="secondary">-</Text>,
    },
    {
      title: '狀態',
      dataIndex: 'is_active',
      key: 'status',
      width: 80,
      render: (active) => (
        <Tag color={active ? 'green' : 'red'}>{active ? '啟用' : '停用'}</Tag>
      ),
    },
    {
      title: '建立時間',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 140,
      render: (d) => d ? new Date(d).toLocaleDateString('zh-TW') : '-',
    },
    {
      title: '操作',
      key: 'actions',
      width: 160,
      render: (_, record) => (
        <Button
          type="primary"
          icon={<LoginOutlined />}
          onClick={() => navigate(`/customers/${record.id}`)}
        >
          進入後台管理
        </Button>
      ),
    },
  ];

  return (
    <div>
      {/* Hero */}
      <div style={{
        background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
        borderRadius: 16, padding: '28px 32px', marginBottom: 24,
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: -30, right: -30, width: 180, height: 180,
          borderRadius: '50%', background: 'rgba(255,255,255,0.08)',
        }} />
        <Title level={3} style={{ color: '#fff', margin: 0 }}>
          <TeamOutlined style={{ marginRight: 8 }} />客戶管理
        </Title>
        <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>
          管理客戶帳號，點選「進入後台管理」可查看及操作客戶的行銷情境與銷售網站
        </Text>
      </div>

      <Card style={{ borderRadius: 12 }}>
        <div style={{ marginBottom: 16 }}>
          <Input
            prefix={<SearchOutlined />}
            placeholder="搜尋客戶名稱、帳號、公司或 Email"
            allowClear
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ maxWidth: 400 }}
          />
        </div>
        <Table
          columns={columns}
          dataSource={filtered}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 20 }}
          locale={{ emptyText: '尚無客戶帳號' }}
        />
      </Card>
    </div>
  );
}
